import React from 'react'

import doneIconSvg from './icons/done-icon.svg?react'
import cancelIconSvg from './icons/cancel-icon.svg?react'
import addIconSvg from './icons/add-icon.svg?react'
import addRowIconSvg from './icons/add-row-icon.svg?react'
import extAddIconSvg from './icons/ext-add-icon.svg?react'
import editIconSvg from './icons/edit-icon.svg?react'
import extEditIconSvg from './icons/ext-edit-icon.svg?react'
import infoIconSvg from './icons/info-icon.svg?react'
import deleteIconSvg from './icons/delete-icon.svg?react'
import upIconSvg from './icons/up-icon.svg?react'
import downIconSvg from './icons/down-icon.svg?react'
import leftIconSvg from './icons/left-icon.svg?react'
import rightIconSvg from './icons/right-icon.svg?react'
import rightUpIconSvg from './icons/right-up-icon.svg?react'
import leftDownIconSvg from './icons/left-down-icon.svg?react'
import expandIconSvg from './icons/expand-icon.svg?react'
import collapseIconSvg from './icons/collapse-icon.svg?react'
import viewIconSvg from './icons/view-icon.svg?react'
import extViewIconSvg from './icons/ext-view-icon.svg?react'
import copyIconSvg from './icons/copy-icon.svg?react'
import shuffleIconSvg from './icons/tools/shuffle-icon.svg?react'
import uuidIconSvg from './icons/uuid-icon.svg?react'
import pomodoroIconSvg from './icons/tools/pomodoro.svg?react'
import stopwatchIconSvg from './icons/tools/stopwatch.svg?react'
import calculatorIconSvg from './icons/tools/calculator-icon.svg?react'
import lockIconSvg from './icons/lock-icon.svg?react'
import passwordIconSvg from './icons/password-icon.svg?react'
import hideIconSvg from './icons/hide-icon.svg?react'
import noteIconSvg from './icons/note-icon.svg?react'
import commentIconSvg from './icons/comment-icon.svg?react'
import markdownIconSvg from './icons/file-types/markdown-icon.svg?react'
import plaintextIconSvg from './icons/file-types/plaintext-icon.svg?react'
import csvTableIconSvg from './icons/file-types/csv-table-icon.svg?react'
import diaryIconSvg from './icons/file-types/diary-icon.svg?react'
import calendarIconSvg from './icons/calendar-icon.svg?react'
import dayBetweenIconSvg from './icons/day-between-icon.svg?react'
import jsonIconSvg from './icons/json-icon.svg?react'
import checkIconSvg from './icons/check-icon.svg?react'
import errorIconSvg from './icons/error-icon.svg?react'
import previewIconSvg from './icons/preview-icon.svg?react'
import restoreIconSvg from './icons/restore-icon.svg?react'
import settingsIconSvg from './icons/settings-icon.svg?react'
import searchIconSvg from './icons/search-icon.svg?react'
import diagramIconSvg from './icons/tools/diagram-icon.svg?react'
import starIconSvg from './icons/star-icon.svg?react'
import treeIconSvg from './icons/tree-icon.svg?react'
import dashboardIconSvg from './icons/dashboard-icon.svg?react'
import plusIconSvg from './icons/plus-icon.svg?react'
import minusIconSvg from './icons/minus-icon.svg?react'
import playIconSvg from './icons/play-icon.svg?react'
import stopIconSvg from './icons/stop-icon.svg?react'
import tagIconSvg from './icons/tag-icon.svg?react'
import listIconSvg from './icons/list-icon.svg?react'
import magic8BallIconSvg from './icons/tools/magic-8-ball-icon.svg?react'
import toolsIconSvg from './icons/tools/tools-icon.svg?react'

export enum IconName {
  Done = 'Done',
  Cancel = 'Cancel',
  Add = 'Add',
  AddRow = 'AddRow',
  ExtAdd = 'ExtAdd',
  Edit = 'Edit',
  ExtEdit = 'ExtEdit',
  Info = 'Info',
  Delete = 'Delete',
  Up = 'Up',
  Down = 'Down',
  Left = 'Left',
  Right = 'Right',
  RightUp = 'RightUp',
  LeftDown = 'LeftDown',
  Expand = 'Expand',
  Collapse = 'Collapse',
  View = 'View',
  ExtView = 'ExtView',
  Copy = 'Copy',
  Shuffle = 'Shuffle',
  Uuid = 'Uuid',
  Pomodoro = 'Pomodoro',
  StopWatch = 'StopWatch',
  Calculator = 'Calculator',
  Lock = 'Lock',
  Password = 'Password',
  Hide = 'Hide',
  Note = 'Note',
  Comment = 'Comment',
  Markdown = 'Markdown',
  Plaintext = 'Plaintext',
  CSVTable = 'CSVTable',
  Diary = 'Diary',
  Calendar = 'Calendar',
  DayBetween = 'DayBetween',
  Json = 'Json',
  Check = 'Check',
  Error = 'Error',
  Preview = 'Preview',
  Restore = 'Restore',
  Settings = 'Settings',
  Search = 'Search',
  Diagram = 'Diagram',
  Star = 'Star',
  Tree = 'Tree',
  Dashboard = 'Dashboard',
  Plus = 'Plus',
  Minus = 'Minus',
  Play = 'Play',
  Stop = 'Stop',
  Tag = 'Tag',
  List = 'List',
  Magic8Ball = 'Magic8Ball',
  Tools = 'Tools',
}

interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: IconName
}

const iconMap = {
  [IconName.Done]: doneIconSvg,
  [IconName.Cancel]: cancelIconSvg,
  [IconName.Add]: addIconSvg,
  [IconName.AddRow]: addRowIconSvg,
  [IconName.ExtAdd]: extAddIconSvg,
  [IconName.Edit]: editIconSvg,
  [IconName.ExtEdit]: extEditIconSvg,
  [IconName.Info]: infoIconSvg,
  [IconName.Delete]: deleteIconSvg,
  [IconName.Up]: upIconSvg,
  [IconName.Down]: downIconSvg,
  [IconName.Left]: leftIconSvg,
  [IconName.Right]: rightIconSvg,
  [IconName.RightUp]: rightUpIconSvg,
  [IconName.LeftDown]: leftDownIconSvg,
  [IconName.Expand]: expandIconSvg,
  [IconName.Collapse]: collapseIconSvg,
  [IconName.View]: viewIconSvg,
  [IconName.ExtView]: extViewIconSvg,
  [IconName.Copy]: copyIconSvg,
  [IconName.Shuffle]: shuffleIconSvg,
  [IconName.Uuid]: uuidIconSvg,
  [IconName.Pomodoro]: pomodoroIconSvg,
  [IconName.StopWatch]: stopwatchIconSvg,
  [IconName.Calculator]: calculatorIconSvg,
  [IconName.Lock]: lockIconSvg,
  [IconName.Password]: passwordIconSvg,
  [IconName.Hide]: hideIconSvg,
  [IconName.Note]: noteIconSvg,
  [IconName.Comment]: commentIconSvg,
  [IconName.Markdown]: markdownIconSvg,
  [IconName.Plaintext]: plaintextIconSvg,
  [IconName.CSVTable]: csvTableIconSvg,
  [IconName.Diary]: diaryIconSvg,
  [IconName.Calendar]: calendarIconSvg,
  [IconName.DayBetween]: dayBetweenIconSvg,
  [IconName.Json]: jsonIconSvg,
  [IconName.Check]: checkIconSvg,
  [IconName.Error]: errorIconSvg,
  [IconName.Preview]: previewIconSvg,
  [IconName.Restore]: restoreIconSvg,
  [IconName.Settings]: settingsIconSvg,
  [IconName.Search]: searchIconSvg,
  [IconName.Diagram]: diagramIconSvg,
  [IconName.Star]: starIconSvg,
  [IconName.Tree]: treeIconSvg,
  [IconName.Dashboard]: dashboardIconSvg,
  [IconName.Plus]: plusIconSvg,
  [IconName.Minus]: minusIconSvg,
  [IconName.Play]: playIconSvg,
  [IconName.Stop]: stopIconSvg,
  [IconName.Tag]: tagIconSvg,
  [IconName.List]: listIconSvg,
  [IconName.Magic8Ball]: magic8BallIconSvg,
  [IconName.Tools]: toolsIconSvg,
}

export const Icon: React.FC<IconProps> = ({ name, className = '', width = '20', height = '20', ...props }) => {
  const SelectedIcon = iconMap[name]

  if (!SelectedIcon) {
    console.error(`Icon "${name}" not found`)
    return <span>Icon not found</span>
  }

  return <SelectedIcon className={className} width={width} height={height} {...props} />
}
